export default __webpack_public_path__ + "static/media/maavuruimage.f880c6e9.png";